import { Laya } from "../../Laya";
import { Sprite } from "../display/Sprite";
import { Text } from "../display/Text";
import { Event } from "../events/Event";
import { Stat } from "./Stat";
export class StatUI {
    constructor() {
        this._show = false;
    }
    createUI() {
        let sp = this._sp = new Sprite();
        sp.scale(Math.max(Laya.stage.clientScaleX, 1), Math.max(Laya.stage.clientScaleY, 1));
        Laya.stage.on(Event.RESIZE, this, () => {
            this._sp.scale(Math.max(Laya.stage.clientScaleX, 1), Math.max(Laya.stage.clientScaleY, 1));
        });
        let leftText = new Text();
        leftText.singleCharRender = true;
        leftText.pos(5, 5);
        leftText.color = "#ffffff";
        leftText.fontSize = fontSize;
        sp.addChild(leftText);
        strArray.length = 0;
        for (let one of this._view)
            strArray.push(one.title);
        leftText.text = strArray.join("\n");
        this._txt = new Text();
        this._txt.singleCharRender = true;
        this._txt.pos(leftText.textWidth + 10, 5);
        this._txt.color = "#ffffff";
        this._txt.fontSize = fontSize;
        sp.addChild(this._txt);
        sp.size(leftText.textWidth + 100, leftText.textHeight + 10);
        sp.graphics.clear();
        sp.graphics.alpha(0.5);
        sp.graphics.drawRect(0, 0, sp.width, sp.height, "#999999");
        sp.graphics.alpha(2);
    }
    show(x, y, views) {
        x = x || 0;
        y = y || 0;
        views = views || Stat.AllShow;
        this._view = views;
        this._show = true;
        if (!this._sp)
            this.createUI();
        this._sp.pos(x, y);
    }
    hide() {
        this._show = false;
    }
    update() {
        if (this._show) {
            strArray.length = 0;
            for (let i = 0; i < this._view.length; i++) {
                let item = this._view[i];
                let isAverage = item.mode == "average";
                let value = Stat[item.value];
                (item.units == "M") && (value = Math.floor(value / (1024 * 1024) * 100) / 100);
                (item.units == "K") && (value = Math.floor(value / (1024) * 100) / 100);
                if (isAverage) {
                    value /= Stat._count;
                    value = Math.floor(value);
                }
                (item.units == "M") && (value += "M");
                (item.units == "K") && (value += "K");
                strArray.push(value);
            }
            this._txt.text = strArray.join("\n");
        }
    }
    render(ctx, x, y) {
        this._show && this._sp && this._sp.render(ctx, 0, 0);
    }
}
const fontSize = 16;
const strArray = [];
Stat._statUIClass = StatUI;
